import { ImplantStatus } from 'common/types'

export function getReadableImplantStatus(
  status: ImplantStatus
): ImplantStatus | string {
  switch (status) {
    case 'IMPLANTED':
      return 'Implanted'
    case 'WASTED':
      return 'Wasted'
    case 'ASSOCIATED_ASSET':
      return 'Associated Product'
    case 'EXPLANTED':
      return 'Explanted'
    case 'NOT_PRESENT':
      return 'Not Present'
    case 'TEMPORARY_IN_OUT':
      return 'Temporary In/Out'
  }
}

export function originalImplantStatus(status: string): ImplantStatus {
  switch (status) {
    case 'Implanted':
      return 'IMPLANTED'
    case 'Wasted':
      return 'WASTED'
    case 'Associated Product':
      return 'ASSOCIATED_ASSET'
    case 'Explanted':
      return 'EXPLANTED'
    case 'Not Present':
      return 'NOT_PRESENT'
    case 'Temporary In/Out':
      return 'TEMPORARY_IN_OUT'
    default:
      return status as ImplantStatus
  }
}
